"use client";

import { LazyMotion, domAnimation } from "motion/react";

/**
 * Lazy-loaded Framer Motion provider. Pairs with `m.div` / `m.span`
 * usage throughout the app instead of `motion.div`. Loads the
 * `domAnimation` feature subset (~5 KB baseline) — covers transforms,
 * opacity, gestures, and AnimatePresence. Drag/layout extras get
 * pulled async only when first used. See:
 * https://motion.dev/docs/react-reduce-bundle-size
 *
 * Wrapped at the root layout so any client component anywhere in the
 * tree can use the lazy `m.*` primitives without re-providing.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
  return <LazyMotion features={domAnimation}>{children}</LazyMotion>;
}
